/*
 * Title: Reconcile Raw Data
 * Description: Stock reconciliation from raw JSON data
 */

import { useAuth } from '../../contexts/AuthContext';
import { ReconcileRawDataProvider } from '../centerWarehouse/reconcileRawData/ContextAPI';
import Index from '../centerWarehouse/reconcileRawData/Index';
import PermissionDenied from './PermissionDenied';

export default function ReconcileRawData() {
    const { auth } = useAuth();
    const { route_permissions } = auth;
    if (!route_permissions['reconcile-raw-data']) return <PermissionDenied />;

    return (
        <ReconcileRawDataProvider>
            <Index />
        </ReconcileRawDataProvider>
    );
}
